import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconShareDoc } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { toggleSlidePanel } from '../../actions';
/**
 * 下部ツールバーのスライド表示ボタン。会話履歴の右に配置される。
 * スライドが出来たタイミング（_attention）でアニメーションしてクリックを促す。
 */
class SlideButtonImpl extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.slideView';
    icon = IconShareDoc;
    label = 'toolbar.slideView';
    tooltip = 'toolbar.slideView';
    _handleClick() {
        this.props.dispatch(toggleSlidePanel());
    }
    /**
     * パネルが開いている間はトグルON（ハイライト）。
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._visible;
    }
    /**
     * 新着時に脈打つバッジを重ねて注意を引く。
     *
     * @override
     * @protected
     * @returns {ReactElement | null}
     */
    _getElementAfter() {
        if (!this.props._attention) {
            return null;
        }
        return (React.createElement("span", { "aria-hidden": true, className: 'slide-attn-badge' }));
    }
}
/**
 * Maps part of the redux state to the component's props.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _visible: state['features/slide-view']?.visible ?? false,
        _attention: state['features/slide-view']?.attention ?? false
    };
}
export default translate(connect(mapStateToProps)(SlideButtonImpl));
